function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* global performance */
(function () {
  'use strict';

  var hasTimezoneRegex = /([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)$/;
  angular.module('wsLrs.directives').factory('PeoplePickerUtils', [function () {
    return {
      personOrGroupKey: function personOrGroupKey(personOrGroup) {
        if (!personOrGroup) {
          return null;
        } else if (personOrGroup.peopleIds) {
          return 'group:' + personOrGroup.id;
        } else if (personOrGroup.personas) {
          return 'person:' + personOrGroup.id;
        } else {
          return 'group-type:' + personOrGroup.name;
        }
      },
      isPersonOrGroupSelected: function isPersonOrGroupSelected(personOrGroup, _ref) {
        var selectedPeopleOrGroups = _ref.selectedPeopleOrGroups;
        var self = this;
        if (!personOrGroup) {
          return false;
        }
        var keys = selectedPeopleOrGroups.map(self.personOrGroupKey);
        return keys.includes(self.personOrGroupKey(personOrGroup));
      },
      isPersonOrGroupExcluded: function isPersonOrGroupExcluded(personOrGroup, _ref2) {
        var excludedPeopleOrGroups = _ref2.excludedPeopleOrGroups;
        var self = this;
        if (!personOrGroup) {
          return false;
        }
        var keys = excludedPeopleOrGroups.map(self.personOrGroupKey);
        return keys.includes(self.personOrGroupKey(personOrGroup));
      }
    };
  }]).factory('VerbPickerUtils', [function () {
    return {
      isSelectedVerb: function isSelectedVerb(ref) {
        return function (verb) {
          var actIds = ref.selectedVerbs.map(function (v) {
            return v.verbId;
          });
          return actIds.includes(verb.verbId);
        };
      },
      isExcludedVerb: function isExcludedVerb(ref) {
        return function (verb) {
          var actIds = ref.excludedVerbs.map(function (v) {
            return v.verbId;
          });
          return actIds.includes(verb.verbId);
        };
      }
    };
  }]).factory('BadgePickerUtils', [function () {
    return {
      isSelectedBadge: function isSelectedBadge(ref) {
        return function (badge) {
          var actIds = ref.selectedBadges.map(function (v) {
            return v.badgeId;
          });
          return actIds.includes(badge.badgeId);
        };
      },
      isExcludedBadge: function isExcludedBadge(ref) {
        return function (badge) {
          var actIds = ref.excludedBadges.map(function (v) {
            return v.badgeId;
          });
          return actIds.includes(badge.badgeId);
        };
      }
    };
  }]).directive('wsPicker', ['$http', '$filter', '$timeout', 'Api', 'Demo', 'wsEventNames', 'Analytics', 'DynamicUser', '$q', 'QuickFilters', 'Utils', function ($http, $filter, $timeout, Api, Demo, wsEventNames, Analytics, DynamicUser, $q, QuickFilters, Utils) {
    return {
      templateUrl: "modules/common/directives/picker/picker.html",
      scope: {
        cfg: "=?"
      },
      link: function link($scope) {
        var time;
        $scope.picker = {
          headline: null,
          itemCount: 0,
          items: null,
          selectedPredicate: null,
          excludedPredicate: null,
          toggleSelection: null,
          averageNameLength: null,
          listFunction: $scope.cfg.listFunction
        };
        $scope.dynamicUser = DynamicUser.getCopy();

        //set local scope variables so that custom card config can reference these
        $scope.customConfig = $scope.cfg.customConfig;
        $scope.workingConfig = $scope.cfg.workingConfig;
        $scope.openDialog = $scope.cfg.openDialog;
        $scope.setPageEvent = wsEventNames.pager.setPickerPage;
        $scope.cfg.clearPickerNavState = function clearPickerNavState() {
          $scope.picker.averageNameLength = null;
          _.each($scope.picker.nav, function (item) {
            item.active = false;
          });
        };
        $scope.cfg.buildPickerView = function buildPickerView(picker) {
          time = performance.now();
          $scope.picker = picker;
          picker.pageSize = picker.pageSize || 42;
          $scope.dynamicUser = DynamicUser.getCopy();
          var params = _defineProperty({}, $scope.cfg.referenceType, $scope.cfg.referenceId);
          if (picker.filterSelect && picker.filter && picker.filter.length > 0) {
            params[picker.filterSelect.param] = picker.filter;
          }
          if (Demo.isDemoMode()) {
            params.demo = true;
          }
          var longWaitTimeout = $timeout(function () {
            $scope.cfg.dialogChoice.pickerLoading = true;
          }, 500);
          picker.countFunction({
            params: params
          }).then(function (count) {
            return $q(function (resolve, reject) {
              //if we have more than 5000 entries we should just skip the count by letter and show everything
              if (count < 5000) {
                // Get the letter count map first...
                picker.countByLetterFunction({
                  params: params
                }).then(function (countByLetter) {
                  picker.countByLetter = countByLetter;
                  picker.totalCount = count;
                  picker.activeLetters = _.keys(countByLetter);
                  if (picker.activeLetters.length === 0) {
                    resolve();
                    return;
                  }
                  if (_.any(picker.activeLetters, function (l) {
                    return l.match(/[^A-Z]/);
                  })) {
                    picker.activeLetters.push('?');
                    picker.countByLetter['?'] = 1;
                  }

                  // If we have more than 100 total items, just show first letter
                  if (picker.totalCount > 100) {
                    var firstLetter = _.find(picker.activeLetters, function (letter) {
                      return letter >= 'A';
                    });
                    picker.letter = firstLetter;
                  } else {
                    picker.letter = null;
                  }

                  // Now list up the first (and maybe only) page
                  $scope.setPickerPage(0);
                  resolve();
                }, function onError(error) {
                  if (error.status === 403) {
                    picker.itemCount = 0;
                    picker.items = [];
                    $scope.setPickerPage(0);
                    reject();
                  }
                });
              } else {
                picker.totalCount = count;
                picker.countByLetter = _.mapObject(_.object('ABCDEFGHIJKLMNOPQRSTUVWXYZ?'.split('')), function () {
                  return 1;
                });
                picker.activeLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ?'.split('');
                picker.letter = 'A';
                $scope.setPickerPage(0);
                resolve();
              }
            });
          }).finally(function () {
            $scope.cfg.dialogChoice.pickerLoading = false;
            $timeout.cancel(longWaitTimeout);
          });
        };
        $scope.choosePickerLetter = function choosePickerLetter(letter) {
          var p = $scope.picker;
          p.letter = letter;
          $scope.setPickerPage(0, true);
        };
        $scope.fetchPickerPage = function (offset, limit) {
          $scope.itemsLoading = true;
          var p = $scope.picker;
          var params = {
            startingLetter: p.letter,
            _limit: limit || p.pageSize,
            _offset: offset,
            order_by: p.orderBy,
            sparse: true
          };
          if ($scope.cfg.referenceType) {
            params[$scope.cfg.referenceType] = $scope.cfg.referenceId;
            params.order_by = QuickFilters.getQuickFilterSortParam($scope.cfg.referenceType, $scope.cfg.referenceId, $scope.picker, params.order_by);
          }
          if (Demo.isDemoMode()) {
            params.demo = true;
          }
          if (p.filterSelect && p.filter && p.filter.length > 0) {
            params[p.filterSelect.param] = p.filter;
          }
          return p.listFunction(params).then(function (results) {
            if (results.results.length > 0 && results.results[0].hasOwnProperty("activityId")) {
              // We have a list of activities so remove dups to handle a quirk where we
              // can see duplicates
              var origSize = results.results.length;
              p.items = _.uniq(results.results, 'activityId');
              var removedCount = origSize - p.items.length;
              p.itemCount = results.count - removedCount;
              _.each(p.items, function (item) {
                item.name = Utils.coalesceActivity(item);
              });
            } else {
              p.items = results.results;
              p.itemCount = results.count;
            }
            _.each(p.items, function (item) {
              if (!item.name) {
                item.name = item.display;
              }
              item.selected = p.selectedPredicate(item);
              item.excluded = p.excludedPredicate(item);
            });
            $scope.itemsLoading = false;
            Analytics.pickerLoaded($scope.picker.itemName, Math.round(performance.now() - time));
            return results;
          });
        };
      }
    };
  }]).directive('wsActivityPicker', ['Activities', 'ActivityTypes', 'TinCanJS', '$http', 'Api', 'Demo', 'Utils', function (Activities, ActivityTypes, TinCanJS, $http, Api, Demo, Utils) {
    return {
      templateUrl: "modules/common/directives/picker/activity-picker.html",
      scope: {
        cfg: "=?"
      },
      link: function link($scope) {
        $scope.addActivity = function addActivity(activity, immutable) {
          activity.name = Utils.coalesceActivity(activity);
          if (!isSelectedActivityOrActivityType(activity)) {
            if (immutable) {
              $scope.cfg.immutableSelection.push(activity);
            } else {
              $scope.cfg.selectedActivities.push(activity);
            }
          }
          $scope.clearActivity();
        };
        $scope.cfg.addActivity = $scope.addActivity;
        $scope.cfg.activitySearchToggleSelect = {
          options: [{
            text: "Activity IDs and Names (default)",
            searchPlaceholder: "Search by Activity IDs and Names (default)",
            state: "include_ids",
            default: true,
            selected: true
          }, {
            text: "Activity IDs only",
            searchPlaceholder: "Search by Activity IDs only",
            state: "exclude_names",
            default: false,
            selected: false
          }, {
            text: "Activity Names only",
            searchPlaceholder: "Search by Activity Names only",
            state: "exclude_ids",
            default: false,
            selected: false
          }],
          selectedOption: {
            text: "Activity IDs and Names (default)",
            searchPlaceholder: "Search by Activity IDs and Names (default)",
            state: "include_ids",
            default: true,
            selected: true
          },
          isDefaultSelected: true,
          dropdownOpen: false
        };
        $scope.removeActivity = function removeActivity(activity, isExcluded) {
          if (isExcluded) {
            $scope.cfg.excludedActivities = _.reject($scope.cfg.excludedActivities, function (act) {
              if (act.activityId) {
                return act.activityId === activity.activityId;
              } else {
                return act.id === activity.id;
              }
            });
          } else {
            $scope.cfg.selectedActivities = _.reject($scope.cfg.selectedActivities, function (act) {
              if (act.activityId) {
                return act.activityId === activity.activityId;
              } else {
                return act.id === activity.id;
              }
            });
          }
        };
        $scope.excludeActivity = function (activity) {
          activity.name = Utils.coalesceActivity(activity);
          $scope.cfg.excludedActivities.push(activity);
          $scope.removeActivity(activity);
        };
        $scope.cfg.excludeActivity = $scope.excludeActivity;
        $scope.clearActivities = function clearActivities(isExcluded) {
          if (isExcluded) {
            $scope.cfg.excludedActivities = [];
          } else {
            $scope.cfg.selectedActivities = [];
          }
          $scope.clearActivity();
        };
        $scope.cfg.clearActivities = $scope.clearActivities;

        // Special custom feature, action to generate measures for child activities of
        // the currently selected activities, see WSLRS-12066
        $scope.childMeasureAggTypes = ["AVG", "SUM", "MAX", "MIN", "LAST", "ANY"];
        $scope.childMeasureAggType = "LAST";
        $scope.childMeasureProperty = {
          statementProperty: "result.score.raw"
        };
        $scope.fetchingChildActivities = false;
        $scope.handleGenerateChildActivityMeasures = function () {
          $scope.fetchingChildActivities = true;
          var reportConfiguration = {
            "filter": {
              "parentActivityIds": {
                "ids": $scope.cfg.selectedActivities.map(function (act) {
                  return act.activityId;
                })
              },
              "verbIds": {
                "ids": ["http://adlnet.gov/expapi/verbs/answered"]
              }
            },
            "version": 3,
            "cachingMinutes": 60,
            "dimensions": [{
              "type": "STATEMENT_PROPERTY",
              "statementProperty": "object.id"
            }],
            "measures": [{
              "name": "ID",
              "aggregation": {
                "type": "ANY"
              },
              "valueProducer": {
                "type": "STATEMENT_PROPERTY",
                "statementProperty": "object.id"
              }
            }, {
              "name": "Interaction Count",
              "aggregation": {
                "type": "COUNT"
              },
              "valueProducer": {
                "type": "STATEMENT_PROPERTY",
                "statementProperty": "object.id"
              }
            }],
            "type": "leaderboard"
          };
          $http.post(Api.url("/aggregation/csv"), reportConfiguration).then(function (r) {
            var childActivities = [];
            var csvRows = Utils.csvToArray(r.data);
            // Start at 1, skipping header row
            for (var i = 1; i < csvRows.length; i++) {
              var actId = csvRows[i][1];
              if (actId && actId.length) {
                childActivities.push({
                  "id": actId,
                  "name": csvRows[i][0]
                });
              }
            }
            var measures = childActivities.map(function (act) {
              return {
                "name": act.name,
                "aggregation": {
                  "type": $scope.childMeasureAggType
                },
                "valueProducer": {
                  "type": "STATEMENT_PROPERTY",
                  "statementProperty": $scope.childMeasureProperty.statementProperty
                },
                "filter": {
                  "activityIds": {
                    "ids": [act.id]
                  }
                }
              };
            });
            $scope.cfg.handleGeneratedChildActivityMeasures(measures);
            $scope.fetchingChildActivities = false;
          });
        };
        function isSelectedActivityOrActivityType(activity) {
          var actIds;
          if (activity.activityId) {
            actIds = _.pluck($scope.cfg.selectedActivities, 'activityId');
            return _.contains(actIds, activity.activityId);
          } else {
            actIds = _.pluck($scope.cfg.selectedActivities, 'id');
            return _.contains(actIds, activity.id);
          }
        }
        function isExcludedActivityOrActivityType(activity) {
          var actIds;
          if (activity.activityId) {
            actIds = _.pluck($scope.cfg.excludedActivities, 'activityId');
            return _.contains(actIds, activity.activityId);
          } else {
            actIds = _.pluck($scope.cfg.excludedActivities, 'id');
            return _.contains(actIds, activity.id);
          }
        }
        function togglePickerActivity(activity) {
          if (!isSelectedActivityOrActivityType(activity) && !isExcludedActivityOrActivityType(activity)) {
            $scope.cfg.selectedActivities.push(activity);
            activity.selected = true;
            activity.excluded = false;
          } else if (!isExcludedActivityOrActivityType(activity)) {
            $scope.removeActivity(activity);
            $scope.cfg.excludedActivities.push(activity);
            activity.selected = false;
            activity.excluded = true;
          } else {
            $scope.removeActivity(activity, true);
            activity.excluded = false;
            activity.selected = false;
          }
        }
        $scope.cfg.buildPicker = function buildActivityPicker() {
          var picker = {
            headline: 'Pick activities and activity types',
            itemName: 'activities',
            orderBy: 'name',
            items: [],
            itemCount: 0,
            selectedPredicate: isSelectedActivityOrActivityType,
            excludedPredicate: isExcludedActivityOrActivityType,
            toggleSelection: togglePickerActivity,
            countFunction: Activities.count.bind(Activities),
            countByLetterFunction: Activities.countByLetter.bind(Activities),
            listFunction: Activities.list.bind(Activities),
            averageNameLength: null,
            filterSelect: null,
            filter: null
          };
          var params = _defineProperty({
            order_by: "name",
            demo: Demo.isDemoMode()
          }, $scope.cfg.pickerConfig.referenceType, $scope.cfg.pickerConfig.referenceId);
          function activityTypeOptions(activityTypes) {
            return _.sortBy(_.map(activityTypes, function (type) {
              return {
                value: type.id,
                id: type.id,
                name: type.name
              };
            }), function (item) {
              return [item.name, item.id];
            });
          }
          $http.get(Api.url("/acc/activity-types"), {
            params: params
          }).then(function (r) {
            var activityTypes = r.data.results;
            if (activityTypes.length > 0) {
              activityTypes = activityTypeOptions(activityTypes);
              picker.filterSelect = {
                noFilterLabel: "All Activity Types",
                param: "type.id",
                options: activityTypes
              };
              picker.nav = [];
              picker.nav.push({
                name: 'Activities',
                action: function action() {
                  $scope.cfg.pickerConfig.clearPickerNavState();
                  $scope.cfg.pickerConfig.buildPickerView(_.extend(picker, {
                    itemName: 'activities',
                    countByLetterFunction: Activities.countByLetter.bind(Activities),
                    countFunction: Activities.count.bind(Activities),
                    listFunction: Activities.list.bind(Activities),
                    selectedPredicate: isSelectedActivityOrActivityType,
                    filterSelect: {
                      noFilterLabel: "All Activity Types",
                      param: "type.id",
                      options: activityTypes
                    },
                    averageNameLength: null,
                    filter: null
                  }));
                }
              });
              picker.nav.push({
                name: 'Activity types',
                action: function action() {
                  $scope.cfg.pickerConfig.clearPickerNavState();
                  $scope.cfg.pickerConfig.buildPickerView(_.extend(picker, {
                    itemName: 'activity-types',
                    countFunction: ActivityTypes.count.bind(ActivityTypes),
                    listFunction: ActivityTypes.list.bind(ActivityTypes),
                    averageNameLength: null,
                    filterSelect: null,
                    filter: null
                  }));
                }
              });
              picker.nav[0].active = true;
            }
            $scope.cfg.pickerConfig.buildPickerView(picker);
          });
        };
      }
    };
  }]).directive('wsPeoplePicker', ['User', 'UserRoles', 'People', 'Groups', 'GroupUtils', '$q', '$http', 'Api', 'Demo', 'PeoplePickerUtils', 'GroupTypes', '$rootScope', 'ExplorerUtils', 'DynamicUser', 'Utils', 'QuickFilters', '$interpolate', function (User, UserRoles, People, Groups, GroupUtils, $q, $http, Api, Demo, PeoplePickerUtils, GroupTypes, $rootScope, ExplorerUtils, DynamicUser, Utils, QuickFilters, $interpolate) {
    return {
      templateUrl: 'modules/common/directives/picker/people-picker.html',
      scope: {
        cfg: "=?",
        dynamicUserLabel: '@'
      },
      link: function wsPeoplePickerLink($scope) {
        // Hide personally identifiable information if user is a Consultant
        $scope.hidePII = UserRoles.isConsultant(User.get());
        $rootScope.$on("organization-selected", function () {
          $scope.hidePII = UserRoles.isConsultant(User.get());
        });
        $scope.searchPlaceholder = Utils._try(function () {
          return $scope.cfg.personPicker.singlePerson;
        }, false) ? 'Search for a person' : 'Search for a person or group';
        setDynamicUserLabel();
        $scope.explorerIsVisible = ExplorerUtils.getIsVisible;
        $scope.personOrGroupSelected = function personOrGroupSelected(personOrGroup, immutable) {
          if (!PeoplePickerUtils.isPersonOrGroupSelected(personOrGroup, $scope.cfg)) {
            if (immutable) {
              $scope.cfg.immutableSelection.push(personOrGroup);
            } else {
              $scope.cfg.selectedPeopleOrGroups.push(personOrGroup);
            }
          }
          if ($scope.clearPersonOrGroup) {
            $scope.clearPersonOrGroup();
          }
        };
        $scope.cfg.personOrGroupSelected = $scope.personOrGroupSelected;
        $scope.removePersonOrGroup = function removePersonOrGroup(personOrGroup, isExcluded) {
          var key = PeoplePickerUtils.personOrGroupKey(personOrGroup);
          if (isExcluded) {
            $scope.cfg.excludedPeopleOrGroups = _.reject($scope.cfg.excludedPeopleOrGroups, function (item) {
              return PeoplePickerUtils.personOrGroupKey(item) === key;
            });
          } else {
            $scope.cfg.selectedPeopleOrGroups = _.reject($scope.cfg.selectedPeopleOrGroups, function (item) {
              return PeoplePickerUtils.personOrGroupKey(item) === key;
            });
          }
        };
        $scope.cfg.removePersonOrGroup = $scope.removePersonOrGroup;
        $scope.clearPeopleAndGroups = function clearPeopleAndGroups() {
          $scope.cfg.selectedPeopleOrGroups = [];
          $scope.clearPersonOrGroup();
        };
        $scope.clearExcludedPeopleAndGroups = function clearPeopleAndGroups() {
          $scope.cfg.excludedPeopleOrGroups = [];
        };
        $scope.excludePersonOrGroup = function (personOrGroup) {
          $scope.cfg.excludedPeopleOrGroups.push(personOrGroup);
          $scope.removePersonOrGroup(personOrGroup);
        };
        $scope.cfg.excludePersonOrGroup = $scope.excludePersonOrGroup;
        $scope.toggleDynamicUser = function () {
          togglePickerPersonOrGroup($scope.dynamicUser);
        };
        $scope.currentUserIcon = function () {
          var selected = PeoplePickerUtils.isPersonOrGroupSelected($scope.dynamicUser, $scope.cfg);
          var excluded = PeoplePickerUtils.isPersonOrGroupExcluded($scope.dynamicUser, $scope.cfg);
          return selected ? 'user-minus' : excluded ? 'user-times' : 'user-plus';
        };
        $scope.getItemName = function (item) {
          return item.id === $scope.dynamicUser.id ? $scope.dynamicUser.name : item.name;
        };

        /**
         * Toggle the personOrGroup between selected, excluded, or deselected.
         * This cycle can be seen by the icon beside the name as the person/group is clicked.
         */
        function togglePickerPersonOrGroup(personOrGroup) {
          var singlePersonPicker = $scope.cfg.personPicker.singlePerson;
          var selectPersonOrGroup = !PeoplePickerUtils.isPersonOrGroupSelected(personOrGroup, $scope.cfg) && !PeoplePickerUtils.isPersonOrGroupExcluded(personOrGroup, $scope.cfg);
          var excludePersonOrGroup = !PeoplePickerUtils.isPersonOrGroupExcluded(personOrGroup, $scope.cfg) && !singlePersonPicker;
          if (selectPersonOrGroup) {
            // If only a single selection is allowed, clear out existing selections
            if ($scope.cfg.personPicker.singlePerson) {
              _.each($scope.cfg.selectedPeopleOrGroups, function (entity) {
                entity.selected = false;
              });
              $scope.cfg.selectedPeopleOrGroups.length = 0;
            }
            $scope.cfg.selectedPeopleOrGroups.push(personOrGroup);
            personOrGroup.selected = true;
            personOrGroup.excluded = false;

            // Close out modal if we only have one selection
            if ($scope.cfg.personPicker.singlePerson) {
              $scope.cfg.pickerConfig.dialog.show = false;
            }
          } else if (excludePersonOrGroup) {
            $scope.removePersonOrGroup(personOrGroup);
            $scope.cfg.excludedPeopleOrGroups.push(personOrGroup);
            personOrGroup.selected = false;
            personOrGroup.excluded = true;

            // Deselect person or group
          } else {
            // If the person picker is only for a single person, they will not be excluded
            // otherwise, they WILL be excluded if they're in this 'else' block
            var isExcluded = !singlePersonPicker;
            $scope.removePersonOrGroup(personOrGroup, isExcluded);
            personOrGroup.selected = false;
            personOrGroup.excluded = false;
          }
        }
        $scope.showIntersectCheckbox = function showIntersectCheckbox() {
          //only show the checkbox if there are at least 2 groups
          return _.chain($scope.cfg.selectedPeopleOrGroups).filter(function (g) {
            return g.peopleIds;
          }).value().length > 1;
        };
        $scope.showExcludeIntersectCheckbox = function showExcludeIntersectCheckbox() {
          return _.chain($scope.cfg.excludedPeopleOrGroups).filter(function (g) {
            return g.peopleIds;
          }).value().length > 1;
        };
        function ensureOrganizationState() {
          $scope.cfg.hasGroups = false;
          return GroupUtils.getGroupCount(Demo.isDemoMode()).then(function (groupCount) {
            $scope.cfg.hasGroups = groupCount > 0;
          });
        }
        $scope.cfg.ensureOrganizationState = ensureOrganizationState;
        ensureOrganizationState();
        function setDynamicUserLabel() {
          $scope.dynamicUser = DynamicUser.getCopy();
          $scope.dynamicUser.setName($scope.dynamicUserLabel);
        }
        function createHeadline() {
          var headline = null;
          if ($scope.hidePII) {
            headline = "Pick groups";
          } else {
            headline = $scope.cfg.personPicker.singlePerson ? "Pick person" : "Pick people";
            if ($scope.cfg.hasGroups && !$scope.cfg.personPicker.singlePerson) {
              headline += " and groups";
            }
          }
          return headline;
        }
        function interpolatePopoverHtml(_ref3) {
          var item = _ref3.item;
          return $interpolate("<span>{{item.name}}</span>")({
            item: item
          });
        }
        function interpolatePersonPopoverHtml(_ref4) {
          var item = _ref4.item;
          return $interpolate("<span>{{item.name}}<br>{{item.personas[0] | personaDisplay}}</span>")({
            item: item
          });
        }

        /**
         * For each nav tab within the people picker, we have a different set of
         * properties that must be configured. So within this function we'll apply
         * the correct override and then return that in order to pass the the picker
         * buildPickerView() function.
         *
         * @param navTabType
         * @param picker
         * @returns {*}
         */
        function extendPickerConfiguration(navTabType, picker) {
          var override = {};
          switch (navTabType.toLowerCase()) {
            case 'people':
              override = {
                itemName: 'people',
                countByLetterFunction: People.countByLetter.bind(People),
                countFunction: People.count.bind(People),
                listFunction: People.list.bind(People),
                averageNameLength: null,
                filterSelect: null,
                filter: null,
                interpolatePopoverHtml: interpolatePersonPopoverHtml
              };
              break;
            case 'groups':
              override = {
                itemName: 'groups',
                countByLetterFunction: Groups.countByLetter.bind(Groups),
                countFunction: function countFunction(cfg) {
                  cfg = cfg || {};
                  cfg.params = cfg.params || {};
                  cfg.params.expandedPermissionsIfAllowed = true;
                  return Groups.count(cfg);
                },
                listFunction: function listFunction(params, cfg) {
                  params = params || {};
                  params.expandedPermissionsIfAllowed = true;
                  return Groups.list(params, cfg);
                },
                averageNameLength: null,
                filterSelect: null,
                filter: null,
                interpolatePopoverHtml: interpolatePopoverHtml
              };
              break;
            case 'group-types':
              override = {
                itemName: 'group-types',
                countByLetterFunction: GroupTypes.countByLetter.bind(GroupTypes),
                countFunction: GroupTypes.count.bind(GroupTypes),
                listFunction: function listFunction(params) {
                  params = params || {};
                  params.expandedPermissionsIfAllowed = true;
                  return GroupTypes.list({
                    params: params
                  });
                },
                averageNameLength: null,
                filterSelect: null,
                filter: null,
                interpolatePopoverHtml: interpolatePopoverHtml
              };
              break;
            default:
              throw new Error('No recognized nav tab for type: ' + navTabType + ' within ws-people-picker');
          }
          return Object.assign({}, picker, override);
        }
        function addPeopleNavTab(navList, extendedPickerConfig) {
          if ($scope.hidePII) {
            return;
          }
          navList.push({
            name: 'Pick people',
            action: function action() {
              $scope.cfg.pickerConfig.clearPickerNavState();
              $scope.cfg.pickerConfig.buildPickerView(extendedPickerConfig);
            }
          });
        }
        function addGroupsNavTab(navList, extendedPickerConfig) {
          navList.push({
            name: 'Pick groups',
            action: function action() {
              $scope.cfg.pickerConfig.clearPickerNavState();
              var params = {
                demo: Demo.isDemoMode()
              };
              var groupTypeSortParam = QuickFilters.getQuickFilterSortParam($scope.cfg.pickerConfig.referenceType, $scope.cfg.pickerConfig.referenceId, {
                itemName: 'group-types'
              }, "displayOrder,name");
              var preRenderRequests = $q.all([$http.get(Api.url("/groups/average-name-length"), {
                params: params
              }), GroupTypes.list({
                params: Object.assign(params, _defineProperty({
                  "_limit": 100,
                  "order_by": groupTypeSortParam,
                  "expandedPermissionsIfAllowed": true
                }, $scope.cfg.pickerConfig.referenceType, $scope.cfg.pickerConfig.referenceId))
              })]);
              preRenderRequests.then(function buildPickerView(responses) {
                var groupTypeResults = responses[1];
                buildGroupTypeDropdownFilter(groupTypeResults, extendedPickerConfig);
                $scope.cfg.pickerConfig.buildPickerView(extendedPickerConfig);
              });
            }
          });
        }
        function addGroupTypesNavTab(navList, extendedPickerConfig) {
          navList.push({
            name: 'Pick group types',
            action: function action() {
              $scope.cfg.pickerConfig.clearPickerNavState();
              $scope.cfg.pickerConfig.buildPickerView(extendedPickerConfig);
            }
          });
        }
        function buildGroupTypeDropdownFilter(_ref5, pickerConfig) {
          var count = _ref5.count,
            results = _ref5.results;
          if (count > 0) {
            pickerConfig.filterSelect = {
              noFilterLabel: "All Group Types",
              param: "type.id",
              options: _.map(results, function (groupType) {
                return {
                  value: groupType.id,
                  name: groupType.name
                };
              })
            };
          }
        }

        /**
         * Danger: We're reverse-binding this method to scope. So this will be called
         * from the controller where $scope.cfg is defined. If this isn't simultaneously
         * bound to a <ws-picker> directive, it will throw errors!
         *
         * So within the same HTML scope you'll need a ws-people-picker and a ws-picker
         * both defined and sharing the same configuration object.
         */
        $scope.cfg.buildPicker = function buildPeopleAndGroupsPicker() {
          setDynamicUserLabel();
          ensureOrganizationState().then(function () {
            var picker = {
              headline: createHeadline(),
              items: [],
              itemCount: 0,
              orderBy: 'name',
              // Can't use the standardized "PeoplePickerUtils.isPersonOrGroupSelected" method
              // here because the buried scope reference will be lost. For now, we'll just put up
              // with the method duplication. However, we should take care to migrate this when
              // we eventually clean up the picker/scope spaghetti.
              // -----
              // The only difference is here, we're checking $scope.cfg and in the standardized method
              // we rely on passing in the list of selectedPeopleOrGroups for clarity and readability.
              selectedPredicate: function isPersonOrGroupSelected(personOrGroup) {
                if (!personOrGroup) {
                  return false;
                }
                var keys = $scope.cfg.selectedPeopleOrGroups.map(PeoplePickerUtils.personOrGroupKey);
                return keys.includes(PeoplePickerUtils.personOrGroupKey(personOrGroup));
              },
              // Same story as above
              excludedPredicate: function isPersonOrGroupExcluded(personOrGroup) {
                if (!personOrGroup) {
                  return false;
                }
                var keys = $scope.cfg.excludedPeopleOrGroups.map(PeoplePickerUtils.personOrGroupKey);
                return keys.includes(PeoplePickerUtils.personOrGroupKey(personOrGroup));
              },
              toggleSelection: togglePickerPersonOrGroup,
              nav: []
            };
            if ($scope.cfg.hasGroups && !$scope.cfg.personPicker.singlePerson) {
              picker.nav = [];
              var peopleTabPickerOverrides = extendPickerConfiguration('people', picker);
              addPeopleNavTab(picker.nav, peopleTabPickerOverrides);
              var groupsTabPickerOverrides = extendPickerConfiguration('groups', picker);
              addGroupsNavTab(picker.nav, groupsTabPickerOverrides);
              var groupTypesTabPickerOverrides = extendPickerConfiguration('group-types', picker);
              addGroupTypesNavTab(picker.nav, groupTypesTabPickerOverrides);
            }

            // Set the first nav to active
            if ($scope.cfg.hasGroups && picker.nav.length > 0) {
              picker.nav[0].active = true;
            }
            if (!$scope.hidePII) {
              $scope.cfg.pickerConfig.buildPickerView(extendPickerConfiguration('people', picker));
            } else if ($scope.cfg.hasGroups && picker.nav.length > 0) {
              picker.nav[0].action();
            }
          });
        };
      }
    };
  }]).directive('wsVerbPicker', ['Verbs', 'VerbPickerUtils', function (Verbs, VerbPickerUtils) {
    return {
      templateUrl: 'modules/common/directives/picker/verb-picker.html',
      scope: {
        cfg: "=?"
      },
      link: function link($scope) {
        var isSelectedVerb = VerbPickerUtils.isSelectedVerb($scope.cfg);
        var isExcludedVerb = VerbPickerUtils.isExcludedVerb($scope.cfg);
        $scope.addVerb = function addVerb(verb, immutable) {
          if (!isSelectedVerb(verb)) {
            if (immutable) {
              $scope.cfg.immutableSelection.push(verb);
            } else {
              $scope.cfg.selectedVerbs.push(verb);
            }
          }
          if ($scope.clearVerb) {
            $scope.clearVerb();
          }
        };
        $scope.cfg.addVerb = $scope.addVerb;
        $scope.removeVerb = function removeVerb(verb, isExcluded) {
          if (isExcluded) {
            $scope.cfg.excludedVerbs = _.reject($scope.cfg.excludedVerbs, function (act) {
              return act.verbId === verb.verbId;
            });
          } else {
            $scope.cfg.selectedVerbs = _.reject($scope.cfg.selectedVerbs, function (act) {
              return act.verbId === verb.verbId;
            });
          }
        };
        $scope.excludeVerb = function (verb) {
          $scope.cfg.excludedVerbs.push(verb);
          $scope.removeVerb(verb);
        };
        $scope.cfg.excludeVerb = $scope.excludeVerb;
        $scope.clearVerbs = function clearVerbs(isExcluded) {
          if (isExcluded) {
            $scope.cfg.excludedVerbs = [];
          } else {
            $scope.cfg.selectedVerbs = [];
          }
          if ($scope.clearVerb) {
            $scope.clearVerb();
          }
        };
        function togglePickerVerb(verb) {
          if (!isSelectedVerb(verb) && !isExcludedVerb(verb)) {
            $scope.cfg.selectedVerbs.push(verb);
            verb.selected = true;
            verb.excluded = false;
          } else if (!isExcludedVerb(verb)) {
            $scope.removeVerb(verb);
            $scope.cfg.excludedVerbs.push(verb);
            verb.selected = false;
            verb.excluded = true;
          } else {
            $scope.removeVerb(verb, true);
            verb.selected = false;
            verb.excluded = false;
          }
        }
        $scope.cfg.buildPicker = function buildVerbPicker() {
          $scope.cfg.pickerConfig.buildPickerView({
            headline: 'Pick verbs',
            itemName: 'verbs',
            orderBy: 'display',
            items: [],
            itemCount: 0,
            selectedPredicate: isSelectedVerb,
            excludedPredicate: isExcludedVerb,
            toggleSelection: togglePickerVerb,
            countByLetterFunction: Verbs.countByLetter.bind(Verbs),
            countFunction: Verbs.count.bind(Verbs),
            listFunction: Verbs.list.bind(Verbs),
            averageNameLength: null
          });
        };
      }
    };
  }]).directive('wsDatePicker', ['Utils', function (Utils) {
    return {
      templateUrl: 'modules/common/directives/picker/date-picker.html',
      scope: {
        cfg: "=?",
        hideAllOption: "<?",
        // Optional; Hide the 'All statement dates' option
        dateTypeLabel: "@",
        // Optional; Label to show for the dateType dropdown
        trailingLabel: "@" // Optional; Label to show for the trailing type, // Optional; Label to show for the trailing type
      },
      link: function link($scope, el, attrs) {
        $scope.selectionOptions = [{
          label: 'Trailing',
          value: 'trailing'
        }, {
          label: 'Custom',
          value: 'custom'
        }];
        $scope.today = new Date();
        $scope.cfg.complexTrailingOption = "0";
        $scope.complexSelectedType = getComplexSelectedType();
        $scope.updateComplexSelectedTrailingSelected = function updateComplexSelectedTrailingSelected() {
          var quarterOrCalendarYearSelected = getComplexSelectedType();
          if (quarterOrCalendarYearSelected !== $scope.complexSelectedType) {
            $scope.cfg.dateFilter.trailingAmount = quarterOrCalendarYearSelected ? 0 : 1;

            // When going from non-complex to complex, we want to reset the select to "current" to
            // match what trailing amount will be
            if (quarterOrCalendarYearSelected) {
              $scope.cfg.complexTrailingOption = '0';
            }
          }
          $scope.complexSelectedType = quarterOrCalendarYearSelected;
        };
        $scope.setTrailingAmount = function setTrailingAmount(amount) {
          $scope.cfg.dateFilter.trailingAmount = amount;
        };
        function _trailingTypeIs(t) {
          return $scope.cfg.dateFilter.trailingType === t;
        }
        function _trailingTypeHasCalendarPrefix() {
          return $scope.cfg.dateFilter.trailingType.startsWith('calendar');
        }
        function trailingTypeHasCalendarPrefix() {
          return Utils._try(function () {
            return _trailingTypeHasCalendarPrefix();
          }, false);
        }
        function _getComplexSelectedType() {
          return _trailingTypeIs('quarter') || _trailingTypeHasCalendarPrefix();
        }
        function getComplexSelectedType() {
          return Utils._try(_getComplexSelectedType, false);
        }
        $scope.updateComplexSelectedType = function updateComplexSelectedType() {
          $scope.complexSelectedType = getComplexSelectedType();
        };
        $scope.getTrailingTypeText = function getTrailingTypeText() {
          var trailingType = $scope.cfg.dateFilter.trailingType || '';
          if (getComplexSelectedType() && trailingTypeHasCalendarPrefix()) {
            return trailingType.substring(0, 8) + ' ' + trailingType.substring(8);
          }
          if ($scope.cfg.dateFilter.trailingAmount === 1 && trailingType.length > 0) {
            return trailingType.substring(0, trailingType.length - 1);
          }
          return trailingType;
        };
        $scope.getTrailingAmountText = function getTrailingAmountText() {
          var trailingAmount = $scope.cfg.dateFilter.trailingAmount;
          if (getComplexSelectedType()) {
            return trailingAmount === '0' || trailingAmount === 0 ? 'current' : 'previous';
          }
          return trailingAmount;
        };
        $scope.getTrailingTypeDateRange = function getTrailingTypeDateRange() {
          var trailingType = $scope.cfg.dateFilter.trailingType;
          var trailingAmount = $scope.cfg.dateFilter.trailingAmount;

          // Not currently supporting days/weeks/months/years
          if (getComplexSelectedType()) {
            return '';
          }
          return calculateComplexTrailingTypeDateRange(trailingType, trailingAmount);
        };
        function calculateComplexTrailingTypeDateRange(trailingType, trailingAmount) {
          switch (trailingType) {
            case 'calendarmonth':
              return calculateCalendarMonthDateRange(trailingAmount);
            case 'quarter':
              return calculateQuarterDateRange(trailingAmount);
            case 'calendaryear':
              return calculateCalendarYearDateRange(trailingAmount);
            default:
              return '';
          }
        }
        function calculateCalendarMonthDateRange(trailingAmount) {
          var currentMonthIndex = $scope.today.getMonth();
          var dateWithMonthOffset = new Date($scope.today.getFullYear(), $scope.today.getMonth(), 1);
          dateWithMonthOffset.setMonth(currentMonthIndex - trailingAmount);
          return '(' + dateWithMonthOffset.toLocaleString('default', {
            month: 'short'
          }) + ')';
        }
        function calculateQuarterDateRange(trailingAmount) {
          var currentMonthIndex = $scope.today.getMonth();
          var currentQuarterIndex = Math.floor(currentMonthIndex / 3);
          var currentQuarterStartMonth = currentQuarterIndex * 3;
          var trailingStartMonth = currentQuarterStartMonth - trailingAmount * 3;
          var firstMonthOfQuarter = new Date($scope.today.getFullYear(), currentMonthIndex, 1);
          firstMonthOfQuarter.setMonth(trailingStartMonth);
          var lastMonthOfQuarter = new Date(firstMonthOfQuarter);
          lastMonthOfQuarter.setMonth(firstMonthOfQuarter.getMonth() + 2);

          // (Jan - Mar [year]) | (Apr - Jun [year] | ETC)
          return '(' + firstMonthOfQuarter.toLocaleString('default', {
            month: 'short'
          }) + ' - ' + lastMonthOfQuarter.toLocaleString('default', {
            month: 'short'
          }) + ' ' + firstMonthOfQuarter.getFullYear() + ')';
        }
        function calculateCalendarYearDateRange(trailingAmount) {
          var currentYear = $scope.today.getFullYear();
          var currentMonth = $scope.today.getMonth();
          var firstMonthForCalendarYear = new Date(currentYear, currentMonth, 1);
          var lastMonthForCalendarYear = new Date(firstMonthForCalendarYear);
          firstMonthForCalendarYear.setMonth(0);
          if (trailingAmount > 0) {
            lastMonthForCalendarYear.setMonth(11);
          }

          // (Jan - [currentMonthOrDec] [year])
          return '(' + firstMonthForCalendarYear.toLocaleString('default', {
            month: 'short'
          }) + ' - ' + lastMonthForCalendarYear.toLocaleString('default', {
            month: 'short'
          }) + ' ' + (firstMonthForCalendarYear.getFullYear() - trailingAmount) + ')';
        }
        $scope.cfg.getTrailingTypeText = $scope.getTrailingTypeText;
        $scope.cfg.getTrailingAmountText = $scope.getTrailingAmountText;
        $scope.cfg.getTrailingTypeDateRange = $scope.getTrailingTypeDateRange;
        if (!$scope.hideAllOption) {
          $scope.selectionOptions.unshift({
            label: 'All statement dates',
            value: 'none'
          });
        }
        if ($scope.cfg.showOlderThan) {
          $scope.selectionOptions.push({
            label: 'Older Than',
            value: 'older_than'
          });
          // If we're showing olderThan, then we're not showing 'trailing'
          $scope.selectionOptions = $scope.selectionOptions.filter(function (o) {
            return o.value !== 'trailing';
          });
        }
        $scope.cfg.toDateOnSelect = function toDateOnSelect(dateText, picker) {
          $scope.$root.$safeApply(function () {
            var toDate = dateText instanceof Date ? dateText : new Date(Date.UTC(picker.selectedYear, picker.selectedMonth, picker.selectedDay));
            toDate.setDate(toDate.getDate() + 1);
            toDate = new Date(toDate.valueOf() - 1);
            $scope.cfg.dateFilter.customDateTo = toDate;

            // Format it as YYYY-MM-DD string so the json serializer doesn't put the Z on the end
            $scope.cfg.dateFilter.customDateTo = $scope.cfg.dateFilter.customDateTo.toISOString().replace('Z', '');
          });
        };
        $scope.cfg.fromDateOnSelect = function fromDateOnSelect(dateText, picker) {
          $scope.$root.$safeApply(function () {
            if (dateText instanceof Date) {
              $scope.cfg.dateFilter.customDateFrom = dateText;
            } else {
              $scope.cfg.dateFilter.customDateFrom = new Date(Date.UTC(picker.selectedYear, picker.selectedMonth, picker.selectedDay));
            }
            var customDateFromStr = $scope.cfg.dateFilter.customDateFrom.toISOString();
            $scope.cfg.dateFilter.customDateFrom = customDateFromStr.replace('Z', '');

            //set min date and default actual date (if needed) for the "to date" when from date changes
            var customDateToPicker = $(".custom-date-to");
            customDateToPicker.datepicker("option", "minDate", dateText);
            //if there is no "to date", use the default of today's date
            if (($scope.cfg.dateFilter.customDateTo || new Date()) < $scope.cfg.dateFilter.customDateFrom) {
              customDateToPicker.datepicker('setDate', dateText);
              $scope.cfg.toDateOnSelect(dateText, $.datepicker._getInst(customDateToPicker[0]));
            }
          });
        };
        $scope.cfg.fromDateOnChangeMonthYear = function fromDateOnChangeMonthYear(year, month, picker) {
          $scope.$root.$safeApply(function () {
            var newFromDate = new Date(Date.UTC(year, month, picker.selectedDay || 1));
            $scope.cfg.fromDateOnSelect(newFromDate, picker);
          });
        };
        $scope.flexLayout = Object.keys(attrs).includes('flex');
        $scope.horizontalLayout = Object.keys(attrs).includes('horizontal');

        // Beware: MORE jquery evil
        $(".custom-date-from").datepicker({
          onSelect: $scope.cfg.fromDateOnSelect,
          changeMonth: true,
          changeYear: true,
          onChangeMonthYear: $scope.cfg.fromDateOnChangeMonthYear
        });
        $(".custom-date-to").datepicker({
          onSelect: $scope.cfg.toDateOnSelect,
          changeMonth: true,
          changeYear: true
        });
        $scope.clearCustomDate = function clearCustomDate(fromOrTo) {
          if (fromOrTo === 'from') {
            $(".custom-date-from").datepicker('setDate', null);
            $scope.cfg.dateFilter.customDateFrom = null;
            $(".custom-date-to").datepicker("option", "minDate", null);
          } else {
            $(".custom-date-to").datepicker('setDate', null);
            $scope.cfg.dateFilter.customDateTo = null;
          }
        };
        $scope.cfg.clearCustomDate = $scope.clearCustomDate;
        function initializeDates() {
          var fromDate = $scope.cfg.dateFilter.customDateFrom,
            toDate = $scope.cfg.dateFilter.customDateTo;

          // TODO: Replace this with function getDateWithTimezone in explorer.js
          //  It does the exact same thing and has the exact same problem described there.
          var fromDateObj;
          if (fromDate && !hasTimezoneRegex.test(fromDate)) {
            // If no timezone
            fromDateObj = new Date(fromDate + "Z");
          } else {
            fromDateObj = new Date(fromDate);
          }
          var toDateObj;
          if (toDate && !hasTimezoneRegex.test(toDate)) {
            // If no timezone
            toDateObj = new Date(toDate + "Z");
          } else {
            toDateObj = new Date(toDate);
          }
          var displayDate;

          // only setup datepickers if from/to dates are valid dateTime format (not relative date strings)
          if (fromDate && fromDateObj.toString() !== 'Invalid Date') {
            var customDateFromPicker = $(".custom-date-from");

            // Adjust date handed to picker to local time, for proper display
            displayDate = new Date(fromDateObj);
            displayDate.setMinutes(displayDate.getMinutes() + fromDateObj.getTimezoneOffset());
            customDateFromPicker.datepicker('setDate', displayDate);
            $scope.cfg.fromDateOnSelect(fromDateObj, $.datepicker._getInst(customDateFromPicker[0]));
          }
          if (toDate && toDateObj.toString() !== 'Invalid Date') {
            var customDateToPicker = $(".custom-date-to");

            // Adjust date handed to picker to local time, for proper display
            displayDate = new Date(toDateObj);
            displayDate.setMinutes(displayDate.getMinutes() + toDateObj.getTimezoneOffset());
            customDateToPicker.datepicker('setDate', displayDate);
          }
          $scope.updateComplexSelectedType();
        }
        if ($scope.cfg.lightTheme) {
          $(".custom-date-picker").removeClass('jquery-ui-vader');
        }

        // Watch this so that if the dateType changes, we can update the custom/trailing
        // selected options to match the model we're interacting with.
        $scope.$watch('cfg.dateFilter', initializeDates);
      }
    };
  }]);
})();
